import { client, handleRequestBody } from "./client.ts";

export interface WeatherSnapshot {
	weather_id: string;
	bucket_time: string;
	temperature_2m: number | null;
	apparent_temperature: number | null;
	relative_humidity_2m: number | null;
	weather_code: number | null;
	cloud_cover: number | null;
	cloud_cover_low: number | null;
	cloud_cover_mid: number | null;
	cloud_cover_high: number | null;
	visibility: number | null;
	rain: number | null;
	precipitation: number | null;
	precipitation_probability: number | null;
	uv_index: number | null;
	uv_index_clear_sky: number | null;
}

export interface Weather {
	latitude: number;
	longitude: number;
	timezone: string;
	utc_offset_seconds: number;
	current: WeatherSnapshot;
	hourly: WeatherSnapshot[];
}

export interface GetWeatherResponse {
	weather: Weather;
}

export function getConstructionWeather(
	constructionId: string,
): Promise<GetWeatherResponse> {
	return handleRequestBody(() =>
		client.get<GetWeatherResponse>(`/constructions/${constructionId}/weather`),
	);
}

export function getWorksiteWeather(
	worksiteId: string,
): Promise<GetWeatherResponse> {
	return handleRequestBody(() =>
		client.get<GetWeatherResponse>(`/worksites/${worksiteId}/weather`),
	);
}
